<div class="row">
  <div class="col-12 form-send-description">
    <p
      *ngIf="mailAvailable; else mailUnavailable"
      [innerHtml]="'components.form-send.description-mail' | translate"
    ></p>
    <ng-template #mailUnavailable>
      <p [innerHtml]="'components.form-send.description' | translate"></p>
    </ng-template>
  </div>
</div>
<mat-accordion *ngIf="mailAvailable; else electronicSendForm">
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header collapsedHeight="*">
      <mat-panel-title>
        <mat-icon>send</mat-icon>
        {{ "components.form-send.electronic-send" | translate }}
      </mat-panel-title>
      <mat-panel-description>
        {{ "components.form-send.electronic-send-description" | translate }}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-container *ngTemplateOutlet="electronicSendForm"></ng-container>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header collapsedHeight="*">
      <mat-panel-title>
        <mat-icon>local_shipping</mat-icon>
        {{ "components.form-send.mail-send" | translate }}
      </mat-panel-title>
      <mat-panel-description>
        {{ "components.form-send.mail-send-description" | translate }}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-container
      *ngTemplateOutlet="downloadButton; context: { attachment: true }"
    ></ng-container>
    <p class="mail-send-warning" [innerHTML]="overrideSendMailWarning || 'components.form-send.mail-send-warning' | translate ">
    </p>
    <p
      [innerHtml]="overrideSendMailAddress || 'components.form-send.mail-send-address' | translate ">
    </p>
  </mat-expansion-panel>
</mat-accordion>
<ng-template #electronicSendForm>
  <ng-container
    *ngTemplateOutlet="downloadButton; context: { attachment: false }"
  ></ng-container>
  <p>
    {{ "components.form-send.electronic-send-detail" | translate }}
  </p>
  <form *ngIf="formGroup" [formGroup]="formGroup">
    <div>
      <ng-container *ngTemplateOutlet="pdfUpload; context: {
        controlName: 'signedPDF',
        label: 'components.form-send.signed-pdf'
      }"></ng-container>
    </div>
    <div>
      <form-email-verification *ngIf="emailVerification" formControlName="emailVerification"></form-email-verification>
      <form-captcha formControlName="captchaVerification"></form-captcha>
      <mat-error
        *ngIf="
          formGroup.get('captchaVerification')?.touched &&
          formGroup.get('captchaVerification')?.hasError('required')
        "
      >
        {{ "forms.errors.field-required" | translate }}
      </mat-error>
    </div>
    <div class="text-end">
      <button mat-raised-button (click)="onCancel()" class="me-2">
        {{ "actions.cancel" | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="onFormSend()">
        {{ "components.form-send.send-button-label" | translate }}
      </button>
    </div>
  </form>
</ng-template>

<ng-template #downloadButton let-attachment="attachment">
  <div class="download-button-container">
    <button
      mat-stroked-button
      color="primary"
      (click)="downloadPdf({ attachment: attachment })"
    >
      {{ "components.form-send.download-pdf" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #pdfUpload let-controlName="controlName" let-label="label">
  <mat-form-field appearance="fill" class="w-100" *ngIf="$any(formGroup.get(controlName)) as control">
    <mat-label>
      {{ label | translate }}
    </mat-label>
    <ngx-mat-file-input
      [formControl]="control"
      [accept]="'application/pdf'"
    ></ngx-mat-file-input>
    <mat-icon matSuffix>upload_file</mat-icon>
    <mat-hint>
      {{ "components.form-send.signed-pdf-help" | translate }}
    </mat-hint>
    <mat-error
      *ngIf="
        formGroup.get(controlName)?.hasError('required');
        else maxContentSize
      "
      translate
    >
      forms.errors.field-required
    </mat-error>
    <ng-template #maxContentSize>
      <mat-error
        *ngIf="formGroup.get(controlName)?.hasError('maxContentSize')"
        translate
        [translateParams]="{
          maxFileSize:
            formGroup.get(controlName)?.getError('maxContentSize').maxSize
            | byteFormat
        }"
      >
        forms.errors.max-file-size
      </mat-error>
    </ng-template>
  </mat-form-field>
</ng-template>
